import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";

export const Container = styled.div`
  margin-top: 10px;
  border-radius: 8px;
  margin: 20px auto;
  max-width: 1180px;
  border: 2px solid ${themes.colors.border};
`;

export const AccordionHandle = styled.div<{
  isExpanded: boolean;
  isSmall: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 30px 10px 10px;
  border-bottom: ${({ isExpanded }) =>
    isExpanded
      ? `2px solid ${themes.colors.border}`
      : `5px solid ${themes.colors.border}`};
  cursor: pointer;
  height: ${({ isSmall }) => (isSmall ? "11px" : "60px")};
  transition: max-height 0.25s ease-in-out;
  &:hover {
    opacity: 0.7;
  }
`;

export const ListLabelWrap = styled.div`
  display: none;
  @media ${device.tablet} {
    font-size: ${themes.textSize.s2};
  }
  @media ${device.desktop} {
    display: flex;
    margin-left: 6px;
    padding: 5px 10px;
    font-size: ${themes.textSize.s2};
    color: ${themes.colors.text};
    border-radius: 6px;
    text-decoration: underline;
    text-decoration-style: dashed;
    text-underline-offset: 4px;
    font-weight: bold;
    font-size: ${themes.textSize.s3};
  }
`;

export const ArrowImage = styled.img`
  width: 28px;
  @media ${device.desktop} {
    width: 35px;
  }
`;

export const AccordionItemWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const SeriesName = styled.h2`
  margin: 0;
  padding: 15px 10px;
  font-size: ${themes.textSize.m1};
  font-weight: bold;
  @media ${device.desktop} {
    font-size: ${themes.textSize.m3};
  }
`;

export const ContentWrapper = styled.div<{
  settingheight: number;
}>`
  height: fit-content;
  max-height: ${({ settingheight }) => `${settingheight}px`};
  transition: max-height 0.25s ease-in-out;
  overflow: scroll;
`;

export const Content = styled.div`
  color: rgba(0, 0, 0, 0.75);
  line-height: 1.5;
`;
